import { createTheme } from "@material-ui/core/styles";

import variants from "./variants";
import typography from "./typography";
import overrides from "./overrides";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";

const makeThemeFromVariant = variant => {
  const createdTheme = createTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      props: props,
      typography: typography,
      shadows: shadows,
      body: variant.body,
      header: variant.header,
      palette: variant.palette,
      sidebar: variant.sidebar
    },
    variant.name
  );

  createdTheme.overrides = overrides(createdTheme);

  return createdTheme
};

const themes = variants.map(makeThemeFromVariant);

export default themes;
